import type { ProjectWithInterviewCount } from "@repo/app-types/entities/project";
import {
  getTagsProvidedByEntity,
  getTagsProvidedByList,
  TagType,
} from "../helpers/tags.js";
import { api } from "../redux.js";

const projectApi = api
  .enhanceEndpoints({
    addTagTypes: [TagType.Project],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      allProjectsForCompany: builder.infiniteQuery<
        {
          projects: ProjectWithInterviewCount[];
          nextCursor: string | null;
        },
        {
          statusFilter?: "live" | "paused";
          typeFilter?: "training";
          sort?: "user";
          limit?: number;
        },
        string | null,
        {
          data: { projects: ProjectWithInterviewCount[] };
          next_cursor: string | null;
        }
      >({
        infiniteQueryOptions: {
          initialPageParam: null,
          getPreviousPageParam: () => null,
          getNextPageParam: (lastPage) => lastPage.nextCursor,
        },
        query: ({ queryArg, pageParam }) => ({
          method: "GET",
          url: "/projects",
          params: {
            cursor: pageParam ?? undefined,
            limit: queryArg.limit ?? 20,
            status_filter: queryArg.statusFilter ?? undefined,
            type_filter: queryArg.typeFilter ?? undefined,
            sort: queryArg.sort ?? undefined,
          },
        }),
        transformResponse: (response) => ({
          projects: response.data.projects,
          nextCursor: response.next_cursor,
        }),
        providesTags: (result) =>
          getTagsProvidedByList(
            TagType.Project,
            result?.pages.flatMap((page) => page.projects),
          ),
      }),

      projectById: builder.query<
        ProjectWithInterviewCount,
        string,
        ProjectWithInterviewCount
      >({
        query: (projectId) => `/projects/${encodeURIComponent(projectId)}`,
        providesTags: (result, error, id) =>
          getTagsProvidedByEntity(TagType.Project, id),
      }),
    }),
  });

export const allProjectsForCompanyEndpoint =
  projectApi.endpoints.allProjectsForCompany;

export const { useAllProjectsForCompanyInfiniteQuery, useProjectByIdQuery } =
  projectApi;
